import { render, staticRenderFns } from "./RechargeRecord.vue?vue&type=template&id=2e2c2d4e&scoped=true&"
import script from "./RechargeRecord.vue?vue&type=script&lang=js&"
export * from "./RechargeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c2d4e",
  null
  
)

export default component.exports